import {
  Avatar,
  Button,
  Col,
  Form,
  Input,
  Layout,
  Menu,
  Modal,
  Popconfirm,
  Rate,
  Row,
  Select,
} from "antd";

import React, {
  ReactElement,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  adminServices,
  getServicePaths,
  isAllowedService,
} from "../../../utils/services";
import { LOGIN_SUCCESS, SIDEBAR_COLLAPSE } from "../../../redux/auth/authType";
import { getImgUrl } from "../../../utils";
import LogoImg from "../../../images/logo.png";
import IconImg from "../../../images/favicon.svg";
import noImage from "../../../images/noImage.png";
import {
  ApartmentOutlined,
  AppstoreOutlined,
  BankOutlined,
  CarryOutOutlined,
  CodepenOutlined,
  ContainerOutlined,
  CopyOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  GiftOutlined,
  IdcardOutlined,
  ProductOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  SoundOutlined,
  SyncOutlined,
  TagOutlined,
  UnorderedListOutlined,
  WechatOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { responseNotification } from "../../../utils/notify";

const { Sider } = Layout;
const { SubMenu } = Menu;

const MainSidebar = (): ReactElement => {
  const { token } = useSelector((state) => (state as any)?.authReducer);
  const { sidebarCollapse, type, shopInfo, merchantInfo } = useSelector(
    (state) => (state as any)?.authReducer
  );
  const location = useLocation();
  const pathname = location.pathname;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState<boolean>(false);
  const [visiblePopconfirm, setVisiblePopconfirm] = useState<any>(undefined);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const [selectedKey, setSelectedKey] = useState<string>("");
  const [salesManBlance, setSalesManBlance] = useState<any>();

  // ✅ NEW: Add mobile + OTP flow states
  const [addMobileOpen, setAddMobileOpen] = useState(false);
  const [otpOpen, setOtpOpen] = useState(false);
  const [mobileInput, setMobileInput] = useState("");
  const [otpInput, setOtpInput] = useState("");
  const [mobileSubmitting, setMobileSubmitting] = useState(false);
  const [otpSubmitting, setOtpSubmitting] = useState(false);

  const [countryCode, setCountryCode] = useState("BD"); // default BD
  const [countryCodeOptions, setCountryCodeOptions] = useState<any>({
    list: [],
    loading: false,
  });


  const setCollapsed = (value: boolean) => {
    dispatch({
      type: SIDEBAR_COLLAPSE,
      payload: {
        sidebarCollapse: value,
      },
    });
  };

  const showPopconfirm = (mobileNumber: any) => {
    setVisiblePopconfirm(mobileNumber);
  };

  const handleCancel = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setVisiblePopconfirm(undefined);
  };

  const onSetDefault = async (shopId: any) => {
    if (shopId) {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          shopInfo: null,
          iat: new Date(),
        },
      });
      navigate("/");
    }
  };

  const getBestMatchKey = (currentPath: string, keys: string[]) => {
    const matched = keys
      .filter((k) => currentPath === k || currentPath.startsWith(k + "/"))
      .sort((a, b) => b.length - a.length)[0];

    return matched || "";
  };

  const adminMenuKeys = useMemo(() => {
    const keys: string[] = [];

    adminServices?.forEach((service: any) => {
      if (service?.sub && service?.sub?.length) {
        const allowedSubItems = service?.sub?.filter((item: any) => {
          return item?.icon && isAllowedService(`${service.name} ${item.name}`);
        });

        if (
          allowedSubItems?.length === 1 &&
          service?.sub?.find((item: any) => item.isParent)
        ) {
          const actualPath = `${service?.path}${service?.sub?.[0]?.path}`;
          keys.push(actualPath);
        } else {
          service?.sub?.forEach((sub: any) => {
            const actualPath = `${service?.path}${sub?.path}`;
            if (!actualPath.includes(":") && sub?.icon) {
              keys.push(actualPath);
            }
          });
        }
      } else if (service?.path) {
        keys.push(service?.path);
      }
    });

    return keys;
  }, []);

  const shopMenuKeys = useMemo(() => {
    const shopId = shopInfo?.id;
    if (!shopId) return ["/"];

    return [
      "/",
      `/shops/${shopId}/myshop-orders`,
      `/shops/${shopId}/myshop-return-order`,

      `/shops/${shopId}/affiliate-products`,

      `/shops/${shopId}/my-shop-products`,
      `/shops/${shopId}/myshop-requested-products`,
      `/shops/${shopId}/myshop-product-catalogue`,
      `/shops/${shopId}/myshop-out-of-stock`,
      `/shops/${shopId}/add-ons`,

      `/my-shop/${shopId}/unsettled-orders`,
      `/my-shop/${shopId}/settled-orders`,

      `/shops/${shopId}/myshop-categories`,

      `/shops/${shopId}/myshop-campaign`,
      `/shops/${shopId}/myshop-promo-code`,

      `/shops/${shopId}/myshop-details`,
      `/shops/${shopId}/shop-business-contract-info`,
      `/shops/${shopId}/shop-business-info`,
      `/shops/${shopId}/shop-banks`,

      `/shops/${shopId}/chats`,
    ];
  }, [shopInfo?.id]);

  const getShopOpenKey = (currentPath: string) => {
    const shopId = shopInfo?.id;
    if (!shopId) return "";

    if (
      currentPath.startsWith(`/shops/${shopId}/myshop-orders`) ||
      currentPath.startsWith(`/shops/${shopId}/myshop-return-order`)
    )
      return "sub4";

    if (
      currentPath.startsWith(`/shops/${shopId}/my-shop-products`) ||
      currentPath.startsWith(`/shops/${shopId}/myshop-requested-products`) ||
      currentPath.startsWith(`/shops/${shopId}/myshop-product-catalogue`) ||
      currentPath.startsWith(`/shops/${shopId}/myshop-out-of-stock`) ||
      currentPath.startsWith(`/shops/${shopId}/add-ons`)
    )
      return "sub2";

    if (
      currentPath.startsWith(`/my-shop/${shopId}/unsettled-orders`) ||
      currentPath.startsWith(`/my-shop/${shopId}/settled-orders`)
    )
      return "sub20";

    if (
      currentPath.startsWith(`/shops/${shopId}/myshop-campaign`) ||
      currentPath.startsWith(`/shops/${shopId}/myshop-promo-code`)
    )
      return "sub3";

    if (
      currentPath.startsWith(`/shops/${shopId}/myshop-details`) ||
      currentPath.startsWith(`/shops/${shopId}/shop-business-contract-info`) ||
      currentPath.startsWith(`/shops/${shopId}/shop-business-info`) ||
      currentPath.startsWith(`/shops/${shopId}/shop-banks`)
    )
      return "sub1";

    return "";
  };

  const fetchSalesManBlance = useCallback(() => {
    try {
      setSalesManBlance({ loading: true, data: null });
      axios
        .get(
          `${process.env.REACT_APP_CATALOG_READER_API}/sales-man?shopId=${shopInfo?.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          if (data.status === 200) {
            setSalesManBlance(data?.data?.salesMan);
          } else {
            setSalesManBlance({ loading: false, data: null });
            responseNotification(
              data.statusText || "something went wrong",
              "error"
            );
          }
        })
        .catch(() => {
          setSalesManBlance({ loading: false, data: null });
        });
    } catch {
      setSalesManBlance({ loading: false, data: null });
    }
  }, [shopInfo?.id, token]);

  const getCountryOptions = useCallback(async (key?: string) => {
    setCountryCodeOptions({ loading: true, list: [] });

    const res = await axios.get(
      `${process.env.REACT_APP_RIDER_API}/admin/country-state/countries?isOperationEnabled=true&page=0&limit=20` +
        (key ? `&key=${key}` : ``),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setCountryCodeOptions({
      loading: false,
      list: res?.data?.countries?.map((country: any) => {
        return {
          value: country?.iso2,
          label: country?.name,
        };
      }),
    });
  }, []);

  useEffect(() => {
    fetchSalesManBlance();
    getCountryOptions();
  }, [fetchSalesManBlance,getCountryOptions]);

  useEffect(() => {
    const isAdmin = shopInfo?.id == null || shopInfo?.id === "";

    if (isAdmin) {
      const best = getBestMatchKey(pathname, adminMenuKeys);
      setSelectedKey(best);

      const open = getServicePaths(pathname);
      setOpenKeys(open ? [open] : []);
    } else {
      const best = getBestMatchKey(pathname, shopMenuKeys);
      setSelectedKey(best);

      const open = getShopOpenKey(pathname);
      setOpenKeys(!sidebarCollapse && open ? [open] : []);
    }
  }, [pathname, shopInfo?.id, sidebarCollapse, adminMenuKeys, shopMenuKeys]);

  const handleOpenChange = (keys: string[]) => {
    setOpenKeys((prev) => {
      const latestOpenKey = keys.find((k) => !prev.includes(k));
      if (!latestOpenKey) return [];
      return [latestOpenKey];
    });
  };

  // ✅ NEW: open mobile modal
  const openAddMobileModal = () => {
    setCountryCode("BD");
    setMobileInput("");
    setOtpInput("");
    setAddMobileOpen(true);
  };

  // ✅ NEW: send otp (you must set real API)
  const sendOtp = async () => {
    const raw = String(mobileInput || "").trim();

    // ✅ user only number দিলে (01xxxxxxxxx) countryCode prefix add হবে
    const normalizedNumber = raw.startsWith("0") ? raw.substring(1) : raw; // 01xxxxxxxxx => 1xxxxxxxxx

    const fullMobile = `${countryCode}${normalizedNumber}`;

    if (!normalizedNumber || normalizedNumber.length < 9) {
      responseNotification("Valid mobile number required", "warning");
      return;
    }

    setMobileSubmitting(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_AUTH_API}/otp/send-register-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mobileNumberOrEmail: mobileInput,
            countryCode: countryCode,
            userType: "SUPER_MERCHANT",
          }),
        }
      );
      const response1 = await res.json();
      if (response1?.statusCode === 200) {
        responseNotification("OTP sent successfully", "success");
        setAddMobileOpen(false);
        setOtpOpen(true);
      } else if (response1.statusCode === 500) {
        responseNotification("Internal server error", "error");
      } else {
        responseNotification(response1.message || "something wrong", "warning");
      }
    } catch (e: any) {
      responseNotification(e?.message || "Failed to send OTP", "error");
    } finally {
      setMobileSubmitting(false);
    }
  };

  // ✅ NEW: verify otp (you must set real API)
  const verifyOtp = async () => {
    const o = String(otpInput || "").trim();
    if (!o || o.length < 4) {
      responseNotification("Valid OTP required", "warning");
      return;
    }

    setOtpSubmitting(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_RIDER_API}/merchant/update-mobile-number`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            countryCode: countryCode,
            mobileNumber: mobileInput,
            otp: o,
          }),
        }
      );

      const response2 = await res.json();

      if (response2?.statusCode === 200) {
        responseNotification("Mobile verified successfully", "success");
        setOtpOpen(false);
        setOtpInput("");
        setMobileInput("");

        // NOTE: You probably refresh merchantInfo from your store after success.
        // If you have an action to refetch merchant profile, call it here.
      }
    } catch (e: any) {
      responseNotification(e?.message || "OTP verification failed", "error");
    } finally {
      setOtpSubmitting(false);
    }
  };

  const isAdminView = shopInfo?.id == null || shopInfo?.id === "";
  const merchantMobile = merchantInfo?.mobileNumber;

  return (
    <>
      <Sider
        width={300}
        collapsible
        collapsed={sidebarCollapse}
        onCollapse={(value) => {
          setCollapsed(value);
        }}
      >
        <div className="logo sticky top-0 z-10">
          <Link to="/">
            <img
              src={sidebarCollapse ? IconImg : LogoImg}
              alt="jachai parcel"
              className="logoImg"
            />
          </Link>
        </div>

        {!sidebarCollapse &&
          (isAdminView ? (
            <div className="bg-transparent text-white shadow-gray-200 border-b mb-4">
              <div className="w-32 h-32 rounded-full bg-gray-100 overflow-hidden mt-5 ml-[25%] relative">
                <img
                  src={
                    merchantInfo?.storeDetails?.profilePicture ||
                    merchantInfo?.merchantPersonalDetail?.profilePicture ||
                    noImage
                  }
                  alt="merchant profile"
                  className="w-full h-full object-cover rounded-full"
                />
              </div>

              <div className="px-4 pb-2">
                <div className=" text-center">
                  <h2 className="text-lg text-white text-center font-bold">
                    {shopInfo?.name ||
                      merchantInfo?.merchantPersonalDetail?.name ||
                      merchantInfo?.storeDetails?.storeName?.toUpperCase() ||
                      merchantInfo?.fullName?.toUpperCase()}
                  </h2>

                  <Rate
                    value={shopInfo?.rating || merchantInfo?.rating || 1}
                    disabled
                  />
                  <span className="bg-blue-100 text-blue-800 text-xs  font-semibold mr-2 px-1 py-0.5 rounded-full dark:bg-blue-200 dark:text-blue-800 ml-2">
                    {shopInfo?.numberOfRating ||
                      merchantInfo?.numberOfRating ||
                      0}
                  </span>
                </div>

                {/* ✅ UPDATED: if merchant mobile null -> show Add Mobile button */}
                <div className="mb-2 text-sm font-medium bg-gray-300 text-slate-800 rounded-md px-2 py-0.5 mt-2">
                  <div className="w-full flex items-center justify-between h-10">
                    <div className="flex-1 text-start">
                    {shopInfo?.mobileNumber?.replace("+88", "") ||
                      merchantInfo?.businessType?.replace("_", " ")}
                    </div>

                    <div className="flex items-center justify-end gap-2">
                      {merchantMobile ? (
                        merchantInfo?.isMobileVerified === true ? (
                          <p className="text-green-700 font-bold m-0">
                            Verified
                          </p>
                        ) : (
                          <p className="text-red-700 font-bold m-0">
                            Unverified
                          </p>
                        )
                      ) : (
                        <Button
                        size="small"
                        type="primary"
                        onClick={openAddMobileModal}
                        style={{
                          borderRadius: 999,
                          padding: "0 14px",
                          height: 28,
                          fontWeight: 600,
                        }}
                      >
                        Add Mobile
                      </Button>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="mb-2 text-sm font-medium text-slate-800 rounded-md px-2 py-5 mt-2"
                  style={{ backgroundColor: "#047E94" }}
                >
                  <Row>
                    <Col span={16}>
                      <h2 className="text-lg font-bold text-white">
                        Jachai Membership
                      </h2>
                      <p className="text-white text-xs">
                        Explore offers with a new seller and enjoy more
                        benefits.
                      </p>
                    </Col>
                    <Col span={8}>
                      <div className="hover:from-pink-500 hover:to-yellow-500 text-white font-bold py-1 mt-6 px-4 rounded-full shadow-md bg-gradient-to-r from-indigo-500 via-pink-500 to-red-500">
                        <Link to="/membership-level">Upgrade</Link>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-transparent text-white shadow-gray-200 border-b mb-4">
              <div className="sm:flex__ xl:block sm:space-x-4 xl:space-x-0">
                <div className="w-full overflow-auto h-48">
                  <img
                    src={shopInfo?.banner || noImage}
                    alt=""
                    className="object-cover w-full"
                  />
                </div>
                <div className="px-4 pb-2">
                  <div className="-mt-12 xl:-mt-20">
                    <Avatar
                      size={100}
                      shape="circle"
                      src={getImgUrl(shopInfo?.logo)}
                      className="mb-5 w-20 h-20 shadow-lg border-4 border-white bg-gray-50"
                    />
                  </div>
                  <div>
                    <h2 className="text-xl text-white font-bold -mt-4">
                      {shopInfo?.name?.toUpperCase()}
                    </h2>

                    {shopInfo?.rating && (
                      <>
                        <Rate
                          value={shopInfo?.rating || 1}
                          className="mt-1"
                          disabled
                        />
                        <span className="bg-blue-100 text-blue-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800 ml-3">
                          {shopInfo?.numberOfRating || 0}
                        </span>
                      </>
                    )}
                  </div>

                  {(shopInfo?.mobileNumber || shopInfo?.balance != null) && (
                    <div className="mb-4">
                      <div className="flex items-start justify-between gap-6">
                        <div className="flex-1">
                          <div className="mt-4 text-sm not-italic font-normal text-gray-500">
                            Balance
                          </div>
                          <div className="mb-2 text-sm font-medium text-white">
                            &#2547;{Number(salesManBlance?.balance || 0)}
                          </div>
                        </div>
                        <div className="flex-1 text-right">
                          <div className="mt-4 text-sm not-italic font-normal text-gray-500">
                            Mobile Number
                          </div>
                          <div className="mb-2 text-sm font-medium text-white">
                            {String(shopInfo?.mobileNumber || "").replace(
                              "+88",
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}

        <Menu
          mode="inline"
          theme="dark"
          selectedKeys={selectedKey ? [selectedKey] : []}
          openKeys={sidebarCollapse ? [] : openKeys}
          onOpenChange={handleOpenChange}
        >
          {isAdminView ? (
            <>
              {adminServices?.map((service: any) => {
                if (service?.sub && service?.sub?.length) {
                  if (
                    service?.sub?.filter((item: any) => {
                      const excludeIcon = item;
                      return (
                        excludeIcon?.icon &&
                        isAllowedService(`${service.name} ${item.name}`)
                      );
                    })?.length === 1 &&
                    service?.sub?.find((item: any) => item.isParent)
                  ) {
                    const actualPath = `${service?.path}${service?.sub?.[0]?.path}`;

                    return (
                      <Menu.Item
                        key={actualPath}
                        icon={<FontAwesomeIcon icon={service?.icon} />}
                      >
                        <Link to={actualPath}>
                          {type == "JC_FOOD"
                            ? service?.name
                                ?.replace("Shops", "Restaurants")
                                ?.replace("Product", "Menu")
                            : service?.name}
                        </Link>
                      </Menu.Item>
                    );
                  } else {
                    return (
                      service?.sub?.find((item: any) =>
                        isAllowedService(`${service.name} ${item.name}`)
                      ) && (
                        <SubMenu
                          key={service?.path}
                          icon={<FontAwesomeIcon icon={service?.icon} />}
                          title={service?.name?.replace("Shops", "Restaurants")}
                        >
                          {service?.sub?.map((sub: any) => {
                            const actualPath = `${service?.path}${sub?.path}`;
                            const excludeIcon = sub;

                            return (
                              !actualPath.includes(":") &&
                              excludeIcon?.icon &&
                              isAllowedService(
                                `${service.name} ${sub.name}`
                              ) && (
                                <Menu.Item
                                  key={actualPath}
                                  icon={<FontAwesomeIcon icon={sub?.icon} />}
                                >
                                  <Link to={actualPath}>{sub?.name}</Link>
                                </Menu.Item>
                              )
                            );
                          })}
                        </SubMenu>
                      )
                    );
                  }
                } else {
                  return (
                    isAllowedService(`${service.name}`) && (
                      <Menu.Item
                        key={service?.path}
                        icon={<FontAwesomeIcon icon={service?.icon} />}
                      >
                        <Link to={service?.path as any}>{service?.name}</Link>
                      </Menu.Item>
                    )
                  );
                }
              })}
            </>
          ) : (
            <>
              <Menu.Item key="/" icon={<AppstoreOutlined />}>
                <Link to={`/`}>Dashboard</Link>
              </Menu.Item>

              <SubMenu
                key={"sub4"}
                icon={<ShoppingCartOutlined />}
                title={"Orders & Review"}
              >
                <Menu.Item
                  key={`/shops/${shopInfo?.id}/myshop-orders`}
                  icon={<UnorderedListOutlined />}
                >
                  <Link to={`/shops/${shopInfo?.id}/myshop-orders`}>
                    Orders List
                  </Link>
                </Menu.Item>

                <Menu.Item
                  key={`/shops/${shopInfo?.id}/myshop-return-order`}
                  icon={<ShoppingOutlined />}
                >
                  <Link to={`/shops/${shopInfo?.id}/myshop-return-order`}>
                    Return Orders
                  </Link>
                </Menu.Item>
              </SubMenu>

              {type !== "JC_BOOKING" && type === "JC_AFFILIATE" ? (
                <Menu.Item
                  key={`/shops/${shopInfo?.id}/affiliate-products`}
                  icon={<ProductOutlined />}
                >
                  <Link to={`/shops/${shopInfo?.id}/affiliate-products`}>
                    Product List
                  </Link>
                </Menu.Item>
              ) : (
                <>
                  <SubMenu
                    key={"sub2"}
                    icon={<ProductOutlined />}
                    title={"Product Management"}
                  >
                    <Menu.Item
                      key={`/shops/${shopInfo?.id}/my-shop-products`}
                      icon={<FileDoneOutlined />}
                    >
                      <Link to={`/shops/${shopInfo?.id}/my-shop-products`}>
                        My Product
                      </Link>
                    </Menu.Item>

                    {merchantInfo?.type !== "RESELLER" && (
                      <Menu.Item
                        key={`/shops/${shopInfo?.id}/myshop-requested-products`}
                        icon={<TagOutlined />}
                      >
                        <Link
                          to={`/shops/${shopInfo?.id}/myshop-requested-products`}
                        >
                          Requested Products
                        </Link>
                      </Menu.Item>
                    )}

                    <Menu.Item
                      key={`/shops/${shopInfo?.id}/myshop-product-catalogue`}
                      icon={<CopyOutlined />}
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/myshop-product-catalogue`}
                      >
                        Product Catalogue
                      </Link>
                    </Menu.Item>

                    <Menu.Item
                      key={`/shops/${shopInfo?.id}/myshop-out-of-stock`}
                      icon={<FileSearchOutlined />}
                    >
                      <Link to={`/shops/${shopInfo?.id}/myshop-out-of-stock`}>
                        Out of Stock
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key={`/shops/${shopInfo?.id}/add-ons`}
                      icon={<FileSearchOutlined />}
                    >
                      <Link to={`/shops/${shopInfo?.id}/add-ons`}>Add Ons</Link>
                    </Menu.Item>
                  </SubMenu>

                  <SubMenu
                    key={"sub20"}
                    icon={<ProductOutlined />}
                    title={"Settlement"}
                  >
                    <Menu.Item
                      key={`/my-shop/${shopInfo?.id}/unsettled-orders`}
                      icon={<FileDoneOutlined />}
                    >
                      <Link to={`/my-shop/${shopInfo?.id}/unsettled-orders`}>
                        Unsettled Orders
                      </Link>
                    </Menu.Item>

                    <Menu.Item
                      key={`/my-shop/${shopInfo?.id}/settled-orders`}
                      icon={<FileDoneOutlined />}
                    >
                      <Link to={`/my-shop/${shopInfo?.id}/settled-orders`}>
                        Settled Orders
                      </Link>
                    </Menu.Item>
                  </SubMenu>

                  <Menu.Item
                    key={`/shops/${shopInfo?.id}/myshop-categories`}
                    icon={<ApartmentOutlined />}
                  >
                    <Link to={`/shops/${shopInfo?.id}/myshop-categories`}>
                      Customize Category
                    </Link>
                  </Menu.Item>

                  <SubMenu
                    key={"sub3"}
                    icon={<GiftOutlined />}
                    title={"My Promotion"}
                  >
                    <Menu.Item
                      key={`/shops/${shopInfo?.id}/myshop-campaign`}
                      icon={<SoundOutlined />}
                    >
                      <Link to={`/shops/${shopInfo?.id}/myshop-campaign`}>
                        Campaign
                      </Link>
                    </Menu.Item>

                    <Menu.Item
                      key={`/shops/${shopInfo?.id}/myshop-promo-code`}
                      icon={<CodepenOutlined />}
                    >
                      <Link to={`/shops/${shopInfo?.id}/myshop-promo-code`}>
                        Promo Code
                      </Link>
                    </Menu.Item>
                  </SubMenu>

                  <SubMenu
                    key={"sub1"}
                    icon={<IdcardOutlined />}
                    title={"Basic Information"}
                  >
                    <Menu.Item
                      key={`/shops/${shopInfo?.id}/myshop-details`}
                      icon={<IdcardOutlined />}
                    >
                      <Link to={`/shops/${shopInfo?.id}/myshop-details`}>
                        General Info
                      </Link>
                    </Menu.Item>

                    <Menu.Item
                      key={`/shops/${shopInfo?.id}/shop-business-contract-info`}
                      icon={<ContainerOutlined />}
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/shop-business-contract-info`}
                      >
                        Business & Contract Info
                      </Link>
                    </Menu.Item>

                    <Menu.Item
                      key={`/shops/${shopInfo?.id}/shop-business-info`}
                      icon={<CarryOutOutlined />}
                    >
                      <Link to={`/shops/${shopInfo?.id}/shop-business-info`}>
                        Business Info
                      </Link>
                    </Menu.Item>

                    <Menu.Item
                      key={`/shops/${shopInfo?.id}/shop-banks`}
                      icon={<BankOutlined />}
                    >
                      <Link to={`/shops/${shopInfo?.id}/shop-banks`}>
                        Bank Info
                      </Link>
                    </Menu.Item>
                  </SubMenu>
                </>
              )}

              <Menu.Item
                key={`/shops/${shopInfo?.id}/chats`}
                icon={<WechatOutlined />}
              >
                <Link to={`/shops/${shopInfo?.id}/chats`}>Chats</Link>
              </Menu.Item>

              <Menu.Item key="switch-to-merchant" icon={<SyncOutlined />}>
                <Popconfirm
                  placement="left"
                  title="Do you want to login this Merchant?"
                  visible={shopInfo?.id === visiblePopconfirm}
                  onConfirm={(e: any) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onSetDefault(shopInfo?.id);
                  }}
                  okButtonProps={{
                    loading: confirmLoading,
                    className: "bg-blue-400",
                    shape: "round",
                  }}
                  cancelButtonProps={{
                    danger: true,
                    type: "primary",
                    shape: "round",
                  }}
                  okText="Yes"
                  cancelText="Not now"
                  onCancel={handleCancel}
                >
                  <Link
                    to={""}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      showPopconfirm(shopInfo?.id);
                    }}
                  >
                    Switch to Merchant
                  </Link>
                </Popconfirm>
              </Menu.Item>
            </>
          )}
        </Menu>
      </Sider>

      {/* ✅ Modal 1: Add Mobile */}
      <Modal
        title="Add Mobile Number"
        open={addMobileOpen}
        onCancel={() => {
          if (!mobileSubmitting) setAddMobileOpen(false);
        }}
        footer={null}
        destroyOnClose
      >
        <div className="space-y-3">
          <div style={{ display: "flex", gap: 8 }}>
            <Select
              value={countryCode}
              style={{ width: 120 }}
              options={countryCodeOptions?.list}
              onChange={(val) => setCountryCode(val)}
            />
            <Input
              placeholder="1XXXXXXXXX"
              value={mobileInput}
              onChange={(e) => setMobileInput(e.target.value)}
            />
          </div>
          <Button
            type="primary"
            className="w-full"
            loading={mobileSubmitting}
            onClick={sendOtp}
          >
            Send OTP
          </Button>
        </div>
      </Modal>

      {/* ✅ Modal 2: OTP */}
      <Modal
        title="Verify OTP"
        open={otpOpen}
        onCancel={() => {
          if (!otpSubmitting) setOtpOpen(false);
        }}
        footer={null}
        destroyOnClose
      >
        <div className="space-y-3">
          <Input
            placeholder="Enter OTP"
            value={otpInput}
            onChange={(e) => setOtpInput(e.target.value)}
          />
          <Button
            type="primary"
            className="w-full"
            loading={otpSubmitting}
            onClick={verifyOtp}
          >
            Verify
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default MainSidebar;
